module.exports = __webpack_public_path__ + "img/1513232939.ea30f92e.jpg";